import {createSignal} from '@pexip/signal';
import type {RemoveParticipantSignal} from '@pexip/media-components';
import type {ParticipantID, RoomID} from '@pexip/infinity';
import {createScheduler} from '@pexip/utils';

import type {RoomParticipantActivity} from '../types';

export const transferParticipantSignal = createSignal<{
    participantUuid?: ParticipantID;
    roomId?: RoomID;
}>({
    name: 'participant:transfer',
});

export const removeParticipantSignal = createSignal<RemoveParticipantSignal>({
    name: 'participant:remove',
});

const PARTICIPANT_ACTIVITY_TIMEOUT = 500;
const PARTICIPANT_ACTIVITY_BUFFER_SIZE = 10;
const participantActivityScheduler = createScheduler({
    delay: PARTICIPANT_ACTIVITY_TIMEOUT,
});

export const participantActivityBatchedSignal =
    createSignal<RoomParticipantActivity>({
        name: 'participant:activities',
        variant: 'batched',
        emitImmediatelyWhenFull: true,
        bufferSize: PARTICIPANT_ACTIVITY_BUFFER_SIZE,
        schedule: participantActivityScheduler.schedule,
    });
